import { render } from "./article.vue?vue&type=template&id=2f0ff5e0&scoped=true&ts=true"
import script from "./article.vue?vue&type=script&lang=ts"
export * from "./article.vue?vue&type=script&lang=ts"

import "./article.vue?vue&type=style&index=0&id=2f0ff5e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0ff5e0"]])

export default __exports__